module.exports = __webpack_public_path__ + "media/assets/icons/alert-info-f5217c25c2682e4eb2a73afe50608ee6.svg";